// 是否停止事件监听处理
let stopMessageHandlerState = false;

export const setStopMessageHandlerState = (value: boolean) => {
  stopMessageHandlerState = value;
};

export const getStopMessageHandlerState = () => stopMessageHandlerState;
